import { render, staticRenderFns } from "./incoming-general-settings.vue?vue&type=template&id=3ec59b62&scoped=true"
import script from "./incoming-general-settings.vue?vue&type=script&lang=js"
export * from "./incoming-general-settings.vue?vue&type=script&lang=js"
import style0 from "./incoming-general-settings.vue?vue&type=style&index=0&id=3ec59b62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec59b62",
  null
  
)

export default component.exports